import BrewingAdmin from "../components/brewingTransaction/BrewingAdmin";

function TestPage4() {
  return <BrewingAdmin />;
}

export default TestPage4;
